// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"400":"c3e6119d","576":"2df138b4","775":"fb120b84"}[chunkId] + ".chunk.js";
};